export default __webpack_public_path__ + "static/mobile-apps-another-reason-59a46c5e88179e8ebd2aa3d4f89f72e6.jpeg";